export default "assets/images/gray-darker-texture-5416d1cc.png";